export enum MenuItemTypeEnum {
  NotSet,
  QuickQuiz,
  MistakesQuiz,
  RevisionSummary,
  OnlineEdition,
  QuestionAndAudio,
  ListeningTracks,
  PracticePapers,
  Extras,
  HighFoundationSwitch,
  NeedHelp,
  MoreFromCGP,
  ExamSkillsVideos,
  Answers,
  HowToRevise,
  VideoExplanations,
  VideoSolutions,
  Writing,
  Reading,
  Speaking,
  QuotationFlashcards,
  Timeline,
  PoetryReadings,
  ExamPracticeQuestions,
  CombinedQuickQuiz,
  CombinedMistakesQuiz,
  CombinedRevisionSummaryQuiz,
  CombinedExamPracticeQuestions,
  CombinedVideoExplanations,
  CombinedVideoSolutions,
  KnowledgeOrganiser,
}
